module.exports = __webpack_public_path__ + "44f14959.svg";